export default __webpack_public_path__ + "static/DSC_0154-d69346b4d958205cbd53a2d6c86d88da.jpg";